import React from 'react';

/** Badge — small pill label. variant: soft | live | muted | gold | success | outline */
export default function Badge({ variant = 'soft', className = '', children, ...rest }) {
  return (
    <span className={`badge badge--${variant}${className ? ` ${className}` : ''}`} {...rest}>
      {variant === 'live' && <span className="badge__dot" aria-hidden="true" />}
      {children}
    </span>
  );
}
